import { Box, Stack, Typography } from '@mui/material'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Modal from '@mui/material/Modal'
import update from 'immutability-helper'
import { useState, useCallback, useEffect } from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { SortableItem } from './SortableItem'
import { styles } from './styles'
import type { Item, ViewSettingsProps } from './types'

// export interface Item {
//   id: number
//   text: string
// }

export const ViewSettings = (props: ViewSettingsProps) => {
  const { open, handleClose, cards, setCards } = props
  const [cardsBuffer, setCardsBuffer] = useState<Item[]>(cards)
  const [allSelected, setAllSelected] = useState<boolean>(
    cardsBuffer.every((card) => card.visible === true)
  )
  // const [cards, setCards] = useState([
  //   {
  //     id: 1,
  //     text: 'Номер',
  //   },
  //   {
  //     id: 2,
  //     text: 'Ф.И.О Водителя',
  //   },
  //   {
  //     id: 3,
  //     text: 'ТС',
  //   },
  //   {
  //     id: 4,
  //     text: 'Гос. номер',
  //   },
  //   {
  //     id: 5,
  //     text: 'Дата составления',
  //   },
  // ])

  useEffect(() => {
    setCardsBuffer(cards)
    setAllSelected(cardsBuffer.every((card) => card.visible === true))
  }, [open])

  const handleSelectAllCards = () => {
    const cards = [...cardsBuffer].map((card) => ({
      ...card,
      visible: !allSelected,
    }))
    setAllSelected(!allSelected)
    setCardsBuffer(cards)
  }
  const handleSelectCard = (index: number) => {
    const cards: Item[] = [...cardsBuffer]
    cards[index] = {
      ...cardsBuffer[index],
      visible: !cardsBuffer[index].visible,
    }
    setAllSelected(cards.every((card) => card.visible === true))
    setCardsBuffer(cards)
  }

  const handleSave = () => {
    setCards(cardsBuffer)
    handleClose()
  }

  const moveCard = useCallback((dragIndex: number, hoverIndex: number) => {
    setCardsBuffer((prevCards: Item[]) =>
      update(prevCards, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, prevCards[dragIndex] as Item],
        ],
      })
    )
  }, [])

  const renderCard = useCallback(
    (card: { id: number; text: string; visible: boolean }, index: number) => {
      return (
        <SortableItem
          key={card.id}
          index={index}
          id={String(card.id)}
          text={card.text}
          moveCard={moveCard}
          selected={card.visible}
          selectCard={handleSelectCard}
        />
      )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [cardsBuffer]
  )

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={styles.root}>
        <Box sx={styles.wrapper}>
          <Box sx={styles.aside}></Box>
          <Box sx={styles.section}>
            <Stack gap={2} mb={2}>
              <Typography variant="h5" component="h5" sx={{ fontWeight: 500 }}>
                Настройки вида
              </Typography>
              <p>
                Чтобы изменить список и порядок отображаемых колонок, выберите
                нужный вид и отметьте интересующие галочкой.
              </p>
            </Stack>
            <Box>
              <Box sx={styles.tableHeader}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={allSelected}
                      onChange={handleSelectAllCards}
                    />
                  }
                  label="Выбрать все"
                />
              </Box>
              <DndProvider backend={HTML5Backend}>
                {cardsBuffer.map((card, i) => renderCard(card, i))}
              </DndProvider>
            </Box>
            <Box sx={styles.buttons}>
              <Stack direction={'row'} gap={2} justifyContent={'flex-end'}>
                <Button variant="outlined" onClick={handleClose}>
                  Отменить
                </Button>
                <Button variant="contained" onClick={handleSave}>
                  Сохранить
                </Button>
              </Stack>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}
